import { IBusStation } from "@/shared/types/busStaition";
import { RootState } from "@/store/redux/store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMapBoundsForBusstaintions } from "../utils/map";
import {
    setBoundsMap,
    setBusStaitionsOnMap,
    setViewPortMapMode,
} from "../store/mapScreenSlce";
import { IFormStation } from "@/services/GET_FROM_OR_TO/types";
import { mapFormStationsToBusStations } from "../utils/map";

interface UseBusStationsOnMapOptions {
    enabled?: boolean;
}

/**
 * Хук, который:
 *  - следит за busStationsShippingFrom / busStationsShippingTo из стора
 *  - маппит их в IBusStation[]
 *  - кладёт в state.mapScreen.busStaitionsOnMap
 *  - обновляет bounds карты
 */
function useStationsMode(options: UseBusStationsOnMapOptions = {}) {
    // const { enabled = true } = options;
    // const dispatch = useDispatch();

    // const { city, mapMode, busStationsShippingFrom, busStationsShippingTo } =
    //     useSelector((state: RootState) => state.mapScreen);

    // function fillBounds(busStations: IBusStation[]) {
    //     const bounds = getMapBoundsForBusstaintions(busStations);
    //     dispatch(setViewPortMapMode("bounds"));
    //     dispatch(setBoundsMap({ values: bounds.bounds, options: bounds.options }));
    // }

    // useEffect(() => {
    //     if (!enabled) return;
    //     if (mapMode !== "busStops") return;
    //     if (!city) return;
    //     const fromStations = mapFormStationsToBusStations(
    //         (busStationsShippingFrom || []) as IFormStation[],
    //         { cityId: city.id, isRoadOverride: false }
    //     );

    //     const toStations = mapFormStationsToBusStations(
    //         (busStationsShippingTo || []) as IFormStation[],
    //         { cityId: city.id, isRoadOverride: false }
    //     );

    //     const allStations: IBusStation[] = [...fromStations, ...toStations];
    //     dispatch(setBusStaitionsOnMap(allStations));

    //     if (allStations.length) {
    //         fillBounds(allStations);
    //     }
    // }, [
    //     enabled,
    //     mapMode,
    //     city,
    //     busStationsShippingFrom,
    //     busStationsShippingTo,
    // ]);
}

export default useStationsMode;